import { Component } from 'react'
import PropTypes from 'prop-types'
import viewportDetection from './detection'
import {
  IS_MOBILE,
  IS_TABLET,
  IS_DESKTOP,
  IS_WIDESCREEN,
  MOBILE,
  TABLET,
  DESKTOP,
  WIDESCREEN
} from './constants'

export default class IsViewport extends Component {
  static get mappings () {
    return [
      [IS_MOBILE, MOBILE],
      [IS_TABLET, TABLET],
      [IS_DESKTOP, DESKTOP],
      [IS_WIDESCREEN, WIDESCREEN]
    ]
  }

  static get propTypes () {
    return {
      [IS_MOBILE]: PropTypes.bool,
      [IS_TABLET]: PropTypes.bool,
      [IS_DESKTOP]: PropTypes.bool,
      [IS_WIDESCREEN]: PropTypes.bool
    }
  }

  constructor (props) {
    super(props)
    this.state = {
      shouldRender: this.shouldRender
    }
    this.onMediaUpdate = this.onMediaUpdate.bind(this)
  }

  get shouldRender () {
    const detections = viewportDetection()
    return IsViewport.mappings.some(
      ([propName, deviceType]) =>
        this.props[propName] && detections[deviceType].matches
    )
  }

  componentDidMount () {
    this.setupListeners({}, this.props)
  }

  componentWillUnmount () {
    this.setupListeners(this.props, {})
  }

  componentWillReceiveProps (nextProps) {
    this.setupListeners(this.props, nextProps)
  }

  setupListeners (props, nextProps) {
    const mappings = IsViewport.mappings
    const detections = viewportDetection()
    mappings.forEach(([propName, deviceType]) => {
      if (nextProps[propName] && !props[propName]) {
        // check added
        detections[deviceType].addListener(this.onMediaUpdate)
      }
      if (props[propName] && !nextProps[propName]) {
        // check removed
        detections[deviceType].removeListener(this.onMediaUpdate)
      }
    })
  }

  onMediaUpdate (event) {
    this.setState({ shouldRender: event.matches || this.shouldRender })
  }

  render () {
    const { children } = this.props
    const { shouldRender } = this.state
    return shouldRender ? children : null
  }
}
